module.exports = __webpack_public_path__ + "assets/on-rebalance.4242dfae.svg";